


































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Movie, TvShow, VoDGenre } from "@/services/apiService/api.types";
import { arrowKeysPreventDefault } from "@/helpers/utils";
import SpatialNavigation from "spatial-navigation-js";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import { Getter } from "vuex-class";
import { Namespace } from "@/store/types";
import { VodPageGetter, VoDType } from "@/components/VoD/types";
import VoDCard from "@/components/VoD/component/VoDCard.vue";
import Swiper, { SwiperOptions } from "swiper";
import copy from "fast-copy";

@Component({
  components: { "vod-card": VoDCard }
})
export default class VodHome extends Vue {
  @Prop() readonly searchFilter!: string;

  @Getter(VodPageGetter.GetViewedVodType, {
    namespace: Namespace.Vod
  })
  getViewedVodType?: VoDType;

  @Getter(VodPageGetter.GetTvShowsByGenre, {
    namespace: Namespace.Vod
  })
  getTvShowsByGenre!: VoDGenre[];

  @Getter(VodPageGetter.GetMoviesByGenre, {
    namespace: Namespace.Vod
  })
  getMoviesByGenre!: VoDGenre[];

  genreSwipers: Swiper[] = [];
  activeSwiperIndex = 0; // determines active/focused swiper instance
  swiperActiveSlideIndexes: number[] = []; //indexes of active elements for each swiper - allows proper focusing when listing through swiper

  smallSwiper = false;

  swiperOptions: SwiperOptions = {
    keyboard: {
      enabled: false
    },
    slidesPerView: 5,
    spaceBetween: 20,
    breakpoints: {
      // when window width is <= 768px
      768: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 20
      }
    }
  };

  created(): void {
    window.addEventListener("resize", () => {
      this.checkWindowWidth();
    });
    // setting initial status
    this.checkWindowWidth();
  }

  mounted(): void {
    this.initializeSwipers();
  }

  initializeSwipers(): void {
    //create all required swiper instances
    this.$nextTick(() => {
      //initializing category swipers
      for (let i = 0; i < this.displayedVodTypeCategories.length; i++) {
        const categorySwiperInstance = new Swiper(
          "#" + this.displayedVodTypeCategories[i].name.replace(/\s/g, ""),
          this.swiperOptions
        );
        this.genreSwipers.push(categorySwiperInstance);
      }
      this.swiperActiveSlideIndexes = new Array(this.genreSwipers.length).fill(
        0
      );
    });
  }

  get activeSwiperInstance(): Swiper {
    return this.genreSwipers[this.activeSwiperIndex];
  }

  async handleVoDGenreActions(event: KeyboardEvent): Promise<void> {
    //preventing page scroll with arrow keys when card controls are selected
    arrowKeysPreventDefault(event);
    let activeSlide = this.swiperActiveSlideIndexes[this.activeSwiperIndex]; //index of active/focused slide of active swiper
    let swiperVodList: TvShow[] | Movie[] = []; //array of items in active swiper
    swiperVodList =
      typeof this.displayedVodTypeCategories[this.activeSwiperIndex]
        .latestTvShows !== "undefined"
        ? (this.displayedVodTypeCategories[this.activeSwiperIndex]
            .latestTvShows as TvShow[])
        : (this.displayedVodTypeCategories[this.activeSwiperIndex]
            .latestMovies as Movie[]);
    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_LEFT:
        if (activeSlide === 0) {
          SpatialNavigation.resume();
          SpatialNavigation.focus("#" + this.$route.name);
          return;
        }

        if (
          (activeSlide >= 2 && activeSlide <= swiperVodList.length - 3) ||
          (this.smallSwiper &&
            activeSlide >= 1 &&
            activeSlide <= swiperVodList.length - 2)
        ) {
          this.activeSwiperInstance?.slidePrev();
        }

        if (activeSlide > 0)
          this.swiperActiveSlideIndexes[this.activeSwiperIndex]--;
        activeSlide--;
        SpatialNavigation.resume();
        break;
      case KeySet.KEY_RIGHT:
        if (
          (activeSlide >= 2 && activeSlide <= swiperVodList.length - 3) ||
          (this.smallSwiper &&
            activeSlide >= 1 &&
            activeSlide <= swiperVodList.length - 2)
        ) {
          this.activeSwiperInstance?.slideNext();
        }

        if (activeSlide < swiperVodList.length)
          this.swiperActiveSlideIndexes[this.activeSwiperIndex]++;
        activeSlide++;
        SpatialNavigation.resume();
        break;
      case KeySet.KEY_DOWN:
        if (this.activeSwiperIndex < this.genreSwipers.length - 1) {
          this.activeSwiperIndex++;
        }
        activeSlide = this.swiperActiveSlideIndexes[this.activeSwiperIndex];
        if (
          typeof this.displayedVodTypeCategories[this.activeSwiperIndex]
            .latestMovies !== "undefined" ||
          typeof this.displayedVodTypeCategories[this.activeSwiperIndex]
            .latestTvShows !== "undefined"
        ) {
          swiperVodList =
            typeof this.displayedVodTypeCategories[this.activeSwiperIndex]
              .latestTvShows !== "undefined"
              ? (this.displayedVodTypeCategories[this.activeSwiperIndex]
                  .latestTvShows as TvShow[])
              : (this.displayedVodTypeCategories[this.activeSwiperIndex]
                  .latestMovies as Movie[]);
        }
        SpatialNavigation.resume();
        setTimeout(() => {
          SpatialNavigation.focus(
            "#" +
              this.getViewedVodType +
              swiperVodList[activeSlide].id +
              this.activeSwiperIndex
          );
        });
        break;
      case KeySet.KEY_UP:
        if (this.activeSwiperIndex > 0) {
          this.activeSwiperIndex--;
          activeSlide = this.swiperActiveSlideIndexes[this.activeSwiperIndex];
          if (
            typeof this.displayedVodTypeCategories[this.activeSwiperIndex]
              .latestMovies !== "undefined" ||
            typeof this.displayedVodTypeCategories[this.activeSwiperIndex]
              .latestTvShows !== "undefined"
          ) {
            swiperVodList =
              typeof this.displayedVodTypeCategories[this.activeSwiperIndex]
                .latestTvShows !== "undefined"
                ? (this.displayedVodTypeCategories[this.activeSwiperIndex]
                    .latestTvShows as TvShow[])
                : (this.displayedVodTypeCategories[this.activeSwiperIndex]
                    .latestMovies as Movie[]);
          }
          SpatialNavigation.resume();
          setTimeout(() => {
            SpatialNavigation.focus(
              "#" +
                this.getViewedVodType +
                swiperVodList[activeSlide].id +
                this.activeSwiperIndex
            );
          });

          return;
        }
        SpatialNavigation.pause();
        SpatialNavigation.focus("#id0");
        break;
    }
  }

  //return only genres of the selected VoD type that are populated with content
  get displayedVodTypeCategories(): VoDGenre[] {
    let filteredVodGenres: VoDGenre[] = [];
    switch (this.getViewedVodType) {
      case VoDType.Movies:
        this.getMoviesByGenre.forEach((vodGenre) => {
          if (
            vodGenre.latestMovies &&
            vodGenre.latestMovies.length > 0 &&
            vodGenre.name !== "Favorites"
          ) {
            const genreDeepCopy = copy(vodGenre);
            genreDeepCopy.latestMovies = genreDeepCopy.latestMovies!.filter(
              (movie) => {
                if (this.searchFilter === "") return true;

                return movie.name.toLowerCase().includes(this.searchFilter);
              }
            );
            filteredVodGenres.push(genreDeepCopy);
          }
        });
        break;
      case VoDType.TvShows:
        this.getTvShowsByGenre.forEach((vodGenre) => {
          if (
            vodGenre.latestTvShows &&
            vodGenre.latestTvShows.length > 0 &&
            vodGenre.name !== "Favorites"
          ) {
            const genreDeepCopy = copy(vodGenre);
            genreDeepCopy.latestTvShows = genreDeepCopy.latestTvShows!.filter(
              (movie) => {
                if (this.searchFilter === "") return true;

                return movie.name.toLowerCase().includes(this.searchFilter);
              }
            );
            filteredVodGenres.push(genreDeepCopy);
          }
        });
        break;
    }
    return filteredVodGenres;
  }

  checkWindowWidth(): void {
    this.smallSwiper = window.innerWidth <= 1200;
  }

  @Watch("displayedVodTypeCategories", { deep: true })
  handleVodCatUpdate(): void {
    this.initializeSwipers();
  }

  isPopulated(genre: VoDGenre): boolean {
    switch (this.getViewedVodType) {
      case VoDType.Movies:
        return genre.latestMovies!.length > 0;
      case VoDType.TvShows:
        return genre.latestTvShows!.length > 0;
    }

    return true;
  }

  beforeDestroy(): void {
    window.removeEventListener("resize", this.checkWindowWidth);
  }
}
